import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { PLAYER } from '../mock/data';

const DemoContext = createContext(null);
const KEY = 'xincity_demo_v1';

const DEFAULT_STATE = {
  loyaltyCoins: PLAYER.loyaltyCoins,
  demoBalance: PLAYER.demoBalance,
  playerMode: 'available',
  investorMode: true,
  ownedItems: ['loyalty-escape-car'],
  missionInviteDismissed: false,
  loyaltyJobStatus: 'none', // none | success | failed | left
  notifications: [
    { id: 1, text: 'Your crew is assembling for The Loyalty Job — 3/4 ready', unread: true },
    { id: 2, text: 'Anna88 sent a message in The Syndicate', unread: true },
    { id: 3, text: 'You reached Level 18 — North Heights unlocks at 30', unread: false },
  ],
};

function load() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_STATE;
    return { ...DEFAULT_STATE, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_STATE;
  }
}

export function DemoProvider({ children }) {
  const [state, setState] = useState(load);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch {}
  }, [state]);

  const api = useMemo(() => ({
    ...state,
    player: PLAYER,
    spendCoins: (amount) => {
      let ok = false;
      setState((s) => {
        if (s.loyaltyCoins >= amount) { ok = true; return { ...s, loyaltyCoins: s.loyaltyCoins - amount }; }
        return s;
      });
      return ok;
    },
    addCoins: (amount) => setState((s) => ({ ...s, loyaltyCoins: s.loyaltyCoins + amount })),
    addBalance: (amount) => setState((s) => ({ ...s, demoBalance: s.demoBalance + amount })),
    ownItem: (id) => setState((s) => s.ownedItems.includes(id) ? s : { ...s, ownedItems: [...s.ownedItems, id] }),
    dismissInvite: () => setState((s) => ({ ...s, missionInviteDismissed: true })),
    setPlayerMode: (mode) => setState((s) => ({ ...s, playerMode: mode })),
    toggleInvestorMode: () => setState((s) => ({ ...s, investorMode: !s.investorMode })),
    setLoyaltyJobStatus: (status) => setState((s) => ({ ...s, loyaltyJobStatus: status })),
    markNotificationsRead: () => setState((s) => ({ ...s, notifications: s.notifications.map((n) => ({ ...n, unread: false })) })),
    resetDemo: () => { setState(DEFAULT_STATE); },
  }), [state]);

  return <DemoContext.Provider value={api}>{children}</DemoContext.Provider>;
}

export function useDemo() {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error('useDemo must be used within DemoProvider');
  return ctx;
}
